import { defaultFantomProviderConfiguration } from 'src/features/on-chain/calculation-manager/providers/dexes/fantom/default-constants';

export const SOUL_SWAP_CONTRACT_ADDRESS = '0x6b3d631B87FE27aF29efeC61d2ab8CE4d621cCBF';

export const SOUL_SWAP_PROVIDER_CONFIGURATION = defaultFantomProviderConfiguration;
